angular.module('ui-ng-session-timer').config(function ($httpProvider) {
  $httpProvider.interceptors.push(function ($q, accountModel) {
    return {
      responseError: function (response) {
        if (response.status === 401 || response.status === 419) {
          /*
           * we can't use $state since $state depends on $httpProvider,
           * so we empty the accountModel which results in a redirect to
           * the landing page
           */
          !response.config.headers.isCampusAPI && accountModel.clear();
        }
        return $q.reject(response);
      }
    };
  });
  // Reset session timer on every http request
  $httpProvider.interceptors.push(function (sessionTimerDelegate) {
    var IS_RESOURCE_REQUEST = /\.\w{3,4}$/i;
    return {
      request: function (config) {
        var hasExtension = IS_RESOURCE_REQUEST.test(config.url);
        var isAnAPIRequest = !hasExtension;
        if (isAnAPIRequest) {
          sessionTimerDelegate.restartSession();
        }
        return config;
      }
    };
  });
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-session-timer/src/config_files/session_timeout_interceptors.es.js